import React from "react";

const Users = () => <div />;
export default Users;
